module.exports = __webpack_public_path__ + "img/67exp.70e05cab.jpg";